module.exports = __webpack_public_path__ + "static/media/bac-vial.5625e419.svg";